import { createFeatureSelector, createSelector } from "@ngrx/store";
import { calculateCoefficientFeatureKey } from "./calculate-coefficient.reducer";

export const selectCalculateCoefficientState = createFeatureSelector(calculateCoefficientFeatureKey);

export const selectCalculateCoefficient = createSelector(
  selectCalculateCoefficientState,
  (state: any) => state
);
